
























































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { accountReceivableService } from '@/shared';
import { Base } from './base';
import { IDialogOption } from '@/models/dialog';
import { mask } from 'vue-the-mask';
import { Countries } from '@/helper/countries';
import { Utils } from '@/helper/utils';
import $ from 'jquery';
import { toHexString } from 'pdf-lib';

@Component({
  computed: {},
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
  props: ['customerKeyValue', 'lastName', 'firstName', 'email'],
  directives: {
    mask,
  },
})
export default class CloverCardsAddressDetails extends Base {
  public cloverCardUrl: string = Utils.WEB_BASE_URL + '/serverpay/clover/card';

  public currentUrl: string = '';

  public tenantId = '';
  public enterpriseId = '';
  public storeId = '';
  public returnUrl = '';
  public cardDetailsInfo: any = {
    customerKey: '',
    tenantId: '',
    enterpriseId: '',
    storeId: '',
    returnUrl: '',
    customerName: '',
    phone: '',
    email: ''
  };


  public cardDetailsLoading: boolean = false;
  public customerSearch: boolean = false;
  public isOutOfSync: boolean=false;

  public addCustomerDialog: IDialogOption = {
    width: 500,
    title: 'Add Card',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Add Card',
      disable: false,
    },
    onAction: (): void => {
      this.continueWithoutUpdate();
    },
    onClose: (): void => {
      this.onClose();
    },
  };

  public async mounted() {
    this.cardDetailsInfo.customerKey = this.$props.customerKeyValue;
    this.cardDetailsInfo.firstName = this.$props.firstName;
    this.cardDetailsInfo.lastName = this.$props.lastName;
    this.cardDetailsInfo.email = this.$props.email;
    this.cardDetailsInfo.phone = this.$props.phoneNumber;
    this.cardDetailsInfo.tenantId = this.userSession.tenantId;
    this.cardDetailsInfo.enterpriseId = this.userSession.enterpriseId;
    this.cardDetailsInfo.storeId = this.userSession.storeId;
    this.currentUrl = window.location.href;

    await this.getCustomerInfo(this.$props.customerKeyValue);
  }

  public onClose() {
    this.$emit('updateCard', false);
  }

  public async getCustomerInfo(customerKey){
    try{
      this.customerSearch = true;
      var res = await accountReceivableService.getSquareCustomer(customerKey);
      this.cardDetailsInfo.firstName = res.firstName;
      this.cardDetailsInfo.lastName = res.lastName;
      this.cardDetailsInfo.email = res.email1;
      this.cardDetailsInfo.phone = res.phoneNumber;
      
    }finally{
      this.customerSearch = false;
      this.addCustomerDialog.model = true;
    }
  }

  public async continueWithoutUpdate() {
    if (await this.validateForm()) {
      try{
        this.addCustomerDialog.loading = true;
        var form = document.getElementById('cloverFormSubmit');
        form.click();

      }finally{
        this.addCustomerDialog.loading = false;
      }
    }
  }
}
